import { Box, Button } from '@mui/material';
import styled from 'styled-components';
import theme from '../../../layouts/theme';

export const SearchInputWrapper = styled(Box)(() => ({
  display: 'flex',
  gap: '16px',
  alignItems: 'flex-end',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  '@media (max-width: 786px)': {
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: '14px'
  }
}));

export const ButtonWrapper = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: 16,
  flexDirection: 'row',
  marginLeft: 'auto',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    width: '100%'
  }
}));

export const StyledButton = styled(Button).attrs({
  variant: 'contained',
  color: 'primary'
})({
  width: 'auto',
  minWidth: '150px',
  borderRadius: '8px !important',
  textWrap: 'nowrap',
  [theme.breakpoints.down('sm')]: {
    width: '100%'
  }
});

export const StyledBox = styled(Box)(() => ({
  display: 'flex',
  gap: '16px',
  flexWrap: 'wrap'
}));
